/* Copyright (c) 2017 Backpack Health LLC */

/* global window */

import localstore from 'store';

export const StorageKeys = {
  AUTH_TOKEN: 'authToken',
  TOKEN_TYPE: 'tokenType',
  LAST_ACTIVE_TIME: 'lastActiveTime',
  LOGOUT_EVENT: 'logoutEvent',
};

const sessionstore = window.sessionStorage
  ? {
    set(key, value) {
      window.sessionStorage.setItem(key, value);
    },

    get(key) {
      return window.sessionStorage.getItem(key);
    },

    remove(key) {
      window.sessionStorage.removeItem(key);
    },

    clearAll() {
      window.sessionStorage.clear();
    },
  }
  : {
    set(key, value) {
      localstore.set(key, value);
    },

    get(key) {
      return localstore.get(key);
    },

    remove(key) {
      localstore.remove(key);
    },

    clearAll() {
      localstore.clear();
    },
  };

const authToken = {

  init(duration, token) {
    localstore.set(StorageKeys.AUTH_TOKEN, token);
  },

  set(token) {
    localstore.set(StorageKeys.AUTH_TOKEN, token);
  },

  get() {
    return localstore.get(StorageKeys.AUTH_TOKEN) || '';
  },

  remove() {
    localstore.remove(StorageKeys.AUTH_TOKEN);
  },

  decode() {
    const tokenParts = this.get().split('.');
    return tokenParts[1] ? window.JSON.parse(window.atob(tokenParts[1])) : {};
  },

};


const lastActiveTime = {

  init(value) {
    localstore.set(StorageKeys.LAST_ACTIVE_TIME, value);
  },

  set(value) {
    localstore.set(StorageKeys.LAST_ACTIVE_TIME, value);
  },

  get() {
    return localstore.get(StorageKeys.LAST_ACTIVE_TIME) || '';
  },

  remove() {
    localstore.remove(StorageKeys.LAST_ACTIVE_TIME);
  },

};

const logoutEvent = {
  init() {
  },

  set() {
    localstore.set(StorageKeys.LOGOUT_EVENT, true);
  },

  get() {
    return localstore.get(StorageKeys.LOGOUT_EVENT) || '';
  },

  remove() {
    localstore.remove(StorageKeys.LOGOUT_EVENT);
  },
};

export { sessionstore, localstore, authToken, lastActiveTime, logoutEvent };
